import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { FooterButtonOption } from 'src/app/model/Enums';
import { Report } from 'src/app/model/report';
import { ReportService } from 'src/app/services';

@Component({
  selector: 'report-footer',
  templateUrl: './report-footer.component.html',
  styleUrls: ['./report-footer.component.scss']
})
export class ReportFooterComponent implements OnInit, OnDestroy {

  @Input() nextBtnText: string = 'Next';
  @Input() nextBtnEnable: boolean = true;

  @Input() backBtnText: string = 'Back';
  @Input() backBtnEnable: boolean = true;

  @Input() skipBtnText: string = 'Skip Question';
  @Input() skipAvailable: boolean = false;
  @Input() skipArrow: boolean = true;

  @Input() extraBtnText: string = 'Extra Question';
  @Input() extraAvailable: boolean = false;
  @Input() extraBtnDisabled: boolean = false;

  @Input() pageId: number = null;
  @Input() mobileIcon: string = '';

  @Output() buttonClicked = new EventEmitter<number>();

  nextRoute: string = '';
  backRoute: string = '';

  public currentReport: Report;
  private reportSub: Subscription;

  reportId: string = '';

  constructor(private reportService: ReportService,
    private router: Router,
    private modalService: BsModalService) {

    this.router.events.subscribe((data: any) => {
      // If routing successful
      if (data instanceof NavigationEnd) {
        if (data.url && data.url.startsWith('/report')) {
          window.scrollTo(0, 0);
        }
      }
    });
  }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  @HostListener('window:keyup.enter', ['$event'])
  onKeyUp($event: KeyboardEvent) {
    const modalBackDrop = document.getElementsByClassName('modal-backdrop');
    if (this.nextBtnEnable && !modalBackDrop?.length) {
      this.nextButtonClick();
    }
  }

  nextButtonClick() {
    this.buttonClicked.emit(FooterButtonOption.NEXT_CLICK);
  }

  backButtonClick() {
    this.buttonClicked.emit(FooterButtonOption.BACK_CLICK);
  }

  skipButtonClick() {
    this.buttonClicked.emit(FooterButtonOption.SKIP_CLICK);
  }

  extraButtonClick() {
    this.buttonClicked.emit(FooterButtonOption.EXTRA_CLICK);
  }

}
